// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IdIdPreviewRouteImport } from './routes/id/$id/preview'
import { Route as IdIdEditRouteImport } from './routes/id/$id/edit'

const IdIdPreviewRoute = IdIdPreviewRouteImport.update({
            id: '/id/$id/preview',path: '/id/$id/preview',getParentRoute: () => rootRouteImport
          })
const IdIdEditRoute = IdIdEditRouteImport.update({
            id: '/id/$id/edit',path: '/id/$id/edit',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IdIdEditRoute: IdIdEditRoute,IdIdPreviewRoute: IdIdPreviewRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)